module.exports = __webpack_public_path__ + "img/info.554ed96e.svg";